<template>
  <a-gradient-border class="team-member__wrapper">
    <div class="team-member__container">
      <div class="team-member__image-wrapper">
        <a-image
          :src="teamMember.imageSrc"
          :alt="teamMember.altText"
          :aspect-ratio="$options.consts.ASPECT_RATIO.TEAM_MEMBER_IMAGE"
          class="team-member__image"
        />
      </div>
      <div class="team-member__text-container">
        <div class="team-member__name secondary-title">
          {{ teamMember.name }}
        </div>
        <div
          v-if="teamMember.position"
          class="team-member__position text-caption"
        >
          {{ teamMember.position }}
        </div>
        <div class="team-member__description text-body-sm">
          {{ teamMember.description }}
        </div>
      </div>
    </div>
  </a-gradient-border>
</template>

<script>
import { PROP_TYPES, propValidator } from '@fmpedia/validators'
import { ASPECT_RATIO } from 'enums/aspectRatios'
import AGradientBorder from 'shared/AGradientBorder/index.vue'

export default {
  name: 'TeamSliderSlide',
  components: { AGradientBorder },
  props: {
    teamMember: propValidator([PROP_TYPES.OBJECT])
  },
  consts: {
    ASPECT_RATIO
  }
}
</script>

<style lang="scss" scoped>
.team-member__wrapper {
  background: linear-gradient(
    to bottom,
    rgba(255, 255, 255, 0.3),
    $c--gray-dark
  );
  border-radius: 16px;

  .team-member__container {
    background-color: $c--coal-black;

    $padding: (
      $above-desktop-xl: 31px,
      $mobile: 22px 18px
    );

    @include setStyleByBreakpoint('padding', $padding);
  }

  .team-member__image-wrapper {
    border-radius: 8px;
    overflow: hidden;
  }

  .team-member__text-container {
    display: flex;
    flex-direction: column;
  }

  .team-member__name {
    font-weight: 600;
    margin-top: 24px;
    margin-bottom: 16px;

    @include mobile {
      font-size: 20px;
      line-height: 30px;
    }
  }

  .team-member__position {
    font-weight: 400;
    margin-bottom: 16px;

    $font-size: (
      $above-desktop-xl: 18px,
      $mobile: 16px
    );

    $line-height: (
      $above-desktop-xl: 28px,
      $mobile: 24px
    );

    @include setStyleByBreakpoint('font-size', $font-size);
    @include setStyleByBreakpoint('line-height', $line-height);
  }

  .team-member__description {
    color: $c--text-secondary;
  }
}
</style>
